<template>
  <div class="shopList homeShop">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="shop_menu_box">
        <van-tabs class="shop_menu" v-model="active" swipeable animated :ellipsis="false" sticky @change="beforeChange">
          <van-tab :class="active == index ? 'item active scrollToItem' : 'scrollToItem item'
            " v-for="(menu, index) in menuList" :key="menu.id + 'menu'" :tabindex="menu.id" :title="menu.cate_name" >
            <!-- @load="onLoad(search)" -->
            <CommodityCom :shopList="list" :key="menu.id + 'CommodityCom'" filter="1" :cate_id="menuList[active].id" />
          </van-tab>
        </van-tabs>
      </div>
    </van-list>
    <div></div>
  </div>
</template>
<script>
import CommodityCom from "@/components/commodity.vue";
import api from "@/request/api";
export default {
  name: "shopCom",
  data() {
    return {
      active: 0,
      index: 0,
      search: {
        sid: null,
        keyword: "",
        priceOrder: "",
        salesOrder: "",
        news: "",
        page: 1,
        limit: 20,
        is_good: 1,
      },
      list: [],
      finished: false,
      loading: false,
      requestCounter: 0
    };
  },
  components: {
    CommodityCom,
  },
  props: {
    indexData: {
      type: Object,
      required: true,
    },
    menuList: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  methods: {
    beforeChange(e) {
      this.active = e;
      this.search.page = 1;
      this.list = [];
      this.finished = true;
      if (e !== 0) {
        this.search.sid = this.menuList[e].id;
      } else {
        this.search.sid = null;
      }
      console.log(this.list);
      this.onLoad();
    },
    async onLoad() {
      try {
        const currentCounter = ++this.requestCounter;
        const result = await api.getProducts(this.search);
        if (result.status === 200) {
          if (result.data.length <= 0) {
            this.finished = true;
            return false;
          } else {
            this.finished = false;
            if (currentCounter === this.requestCounter) {
              this.search.page++;
              this.list = this.list.concat(result.data);
            }
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>

</style>
